/**
 * Settings -> Integrations: the Google key Saidiseire's weekly speed test asks
 * PageSpeed Insights with (docs/saidiseire-kiirus-turve-raport.md, item C).
 *
 * Without a key nothing is measured: the Google API's keyless quota is zero
 * in practice, so the speed card on a site page says the key is missing and
 * links here. The key is its own, restricted to the PageSpeed Insights API,
 * rather than the Web Risk or Maps key, so each stays limited to one API.
 *
 * No connection test, like the Web Risk panel: the next weekly run is the
 * honest test, and a key Google refuses shows up as an error on the site's
 * speed card.
 *
 * Under the key, the call budget (`PagespeedBudget`): today's and this
 * month's use against the limits, and the limits themselves, 25 000 a day
 * (Google's daily quota) and 750 000 a month unless a manager changed them.
 */
import { Gauge } from "lucide-react";
import { useT } from "../../../../i18n/I18nProvider";
import { ConnStatus, IntegrationCard, PanelLoader } from "../panel/IntegrationCard";
import { Note } from "../panel/fields";
import { MonitorKeyForm, useMonitorKeys } from "./MonitorKeyForm";
import { PagespeedBudget } from "./PagespeedBudget";

export function PagespeedCard() {
  const t = useT();
  const { view, loading, setView } = useMonitorKeys();

  if (loading) return <PanelLoader />;
  if (!view) return null;

  return (
    <IntegrationCard
      icon={Gauge}
      title={t("settings.pagespeed.title")}
      desc={t("settings.pagespeed.desc")}
      status={<ConnStatus ok={view.pagespeed.keySet} okLabel={t("settings.pagespeed.on")} offLabel={t("settings.pagespeed.off")} />}
    >
      <Note tone="info">{t("settings.pagespeed.what")}</Note>
      <p className="crm-sub mb-3 text-[13px]">{t("settings.pagespeed.where")}</p>
      <MonitorKeyForm name="pagespeed" keySet={view.pagespeed.keySet} onSaved={setView} />
      <PagespeedBudget budget={view.pagespeed.budget} onSaved={setView} />
    </IntegrationCard>
  );
}
